import { secondsToTime } from './secondsToTime';

export const getGmtOffsetString = (offset: number) => {
  const { hours } = secondsToTime(Math.abs(offset));
  const sign = offset >= 0 ? '+' : '-';
  return `(GMT${sign}${hours})`;
};
